import { createSelector } from '@reduxjs/toolkit';
import { StateType } from '../../../types';

export const getCreateLead = createSelector(
  (state: StateType) => state.expertDirectory,
  (expertDirectory) => expertDirectory.createLead,
);
